import { render, staticRenderFns } from "./defaultChat.vue?vue&type=template&id=3f3e985e&scoped=true&lang=pug&"
import script from "./defaultChat.vue?vue&type=script&lang=ts&"
export * from "./defaultChat.vue?vue&type=script&lang=ts&"
import style0 from "./defaultChat.vue?vue&type=style&index=0&id=3f3e985e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3e985e",
  null
  
)

export default component.exports